import { useSelector } from 'react-redux';

const useGetCarAddOnSelection = () => {
    return useSelector((state) => state.addOnSelection.car_addOn_selection);
};

export default useGetCarAddOnSelection;